import React, { Component } from 'react';
import "./index.less";
import { getPlatformName, requests, messageShow, getLoginShopInfo,matchSupplierProduct, systemConfig } from '../../utils/http';
import PlatformName from '../../components/platformName/index.jsx';
import ShowModal from '../../components/showModal/index.jsx';
import { Tabs,MessageBox } from 'element-react';
import TableNavChange from '../../components/tableNavChange/tableNavChange';
import MyLoading from '../../components/showLoading/showLoading';
import $ from 'jquery';
import { ImageSearchProductRequest,MatchTaoteLinkRequest,loadSupplierProduct } from '../../utils/api';
import { withRouter } from 'react-router-dom';
import { otherExposureReport } from '../../utils/alibabareport.js';

class ChangeProductsModule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      loadingTitle: '',
      isShowDailog: props.showModal,
      changeStatus: 'first',//找关联货源 步骤
      changeSameProductStatus: 'first',//找同款 步骤
      isShowWarnText: false,
      confrimChangeProduct: false,
      isShowChangeProduct: false,
      hasLoadBorder: false,
      noticeText: "",
      selectProduct: null,//选择的商品
      selectedShopProduct: props.selectedShopProduct,
      selectProductSkuId: props.selectProductSkuId,//选择了哪个店铺商品的sku的下拉框。（选择1688商品sku框）
      supplierProduct: null,//供应商商品
      supplierProductSkuList: [],//供应商商品sku
      productTag: props.productTag,
      TargetShopPt: '',
      TargetShopId: '',
      activeId: props.activeSearchNavId ? props.activeSearchNavId : 0,
      changeProduct: null,
      changeSameProduct: null,
      changeSearchNavs: [
        { id: 0, value: "", title: "链接关联货源", active: false, },
        { id: 1, value: "", title: "找同款关联", active: false, },
      ],
      salesCntSort: 0,//同款货源推荐销量从高到底 排序
      minPriceSort: 0,//价格  排序
      hideTTHelp: false,
      supplierProductList: [],// 找同款商品列表
      selectedShopProductImgSrc: props.selectedShopProductImgSrc,
      isSupplierProductList: true,
      selectProductId: props.selectProductId,
      title:props.title?props.title:'更换货源',
      selectSourcePlatformNav:'AlibabaZhuKe',
      isTempRelevanceProduct:props.isTempRelevanceProduct,//提示是否临时替换货源
      isOnlyOrderDialog:false,//更换货源时，是否针仅对当前订单保存代销关系

      changeProductsModuleAction:null,//2 == 更换规格
    };
  }
  componentDidMount() { //组件挂载到DOM渲染后被执行，只会执行一次。

    var shopInfo = getLoginShopInfo();
    if (shopInfo.loginShopId == "" || shopInfo.loginShopPlatformType == "") {
      var setIntervalTimer = setInterval(() => {
        shopInfo = getLoginShopInfo();
        if (shopInfo.loginShopId != "" && shopInfo.loginShopPlatformType != "") {
          this.setState({
            TargetShopId: shopInfo.loginShopId,
            TargetShopPt: shopInfo.loginShopPlatformType,
          })
          clearInterval(setIntervalTimer);
        }
      }, 500)
    }
    var activeId = this.state.activeId;
    var changeSearchNavs = this.state.changeSearchNavs;

    setTimeout(() =>{
      changeSearchNavs.forEach((item, index) => {
        item.active = false;
        if (item.id == activeId) {
          item.active = true;
        }
      })
      this.setState({ changeSearchNavs })
    },500)
    
  }
  componentWillReceiveProps(props) {  //监听父元素 传过来值的变化 触发的函数
    if(props.showModal != this.state.isShowDailog && props.showModal == true){
      let activeId = props.activeSearchNavId ? props.activeSearchNavId : 0;
      let changeSearchNavs = this.state.changeSearchNavs;
      var shopInfo = getLoginShopInfo();
      this.setState({
        TargetShopId: shopInfo.loginShopId,
        TargetShopPt: shopInfo.loginShopPlatformType,
        isShowDailog: props.showModal,
        selectedShopProduct: props.selectedShopProduct,
        selectProductSkuId: props.selectProductSkuId,
        productTag: props.productTag,
        activeId: activeId,
        isTempRelevanceProduct:props.isTempRelevanceProduct,
        tempPlatformOrderId:props.tempPlatformOrderId,
        tempOrderCode:props.tempOrderCode,
        tempOrderItemCode:props.tempOrderItemCode,
        selectSupplierProductId:props.selectedSupplierProductId,
        title:props.title?props.title:'更换货源'
      })


      changeSearchNavs.forEach((item, index) => {
        item.active = false;
        if (item.id == activeId) {
          item.active = true;
        }
        if (item.id == 0) {
          this.setState({ supplierProductList: [] })
        }
      })
      this.setState({ changeSearchNavs });
      if (props.showModal) {
        this.setState({
          selectProductId: props.selectProductId,
          selectedShopProductImgSrc: props.selectedShopProductImgSrc
        }, () => {
          if(activeId == 0 && props.changeProductsModuleAction)//非图搜，查代销关系的，直接在规格映射的那部
          {
            this.changeTemporaryRelation();
          }
          else
            this.getSelectProductInfo();  //获取选中商品详细详情
        })
      }
      if (activeId == 1 && props.showModal) {
        this.getSupplierProductList(props.selectedShopProductImgSrc);
      }
    }
  }

  //切换 链接关联货源  找同款关联 导航
  changeNav = (e) => {
    this.setState({
      activeId: e.id
    })
    if (e.id == 1) {
      otherExposureReport("tktj");
      this.getSupplierProductList(this.state.selectedShopProductImgSrc);

    }
  }
  getSupplierProductList(selectedShopProductImgSrc) { //获取同步商品列表
    if(!selectedShopProductImgSrc){
      selectedShopProductImgSrc = this.state.selectedShopProductImgSrc
    }
    let sourcePlatform = $("input[name=selectSourcePlatform]:checked").val()
    if(!sourcePlatform){
      sourcePlatform = this.state.selectSourcePlatformNav
    }else{
      this.state.selectSourcePlatformNav = sourcePlatform
    }
    this.state.needBindBuyerShop = ''
    this.setState({ isLoading: true, loadingTitle: '获取商品中...' });
    this.translateImgToBase64(selectedShopProductImgSrc, 2, (base64) => {
      this.setState({ supplierProductList: [] }, async () => {
        let data = {
          SourcePlatform: sourcePlatform,
          Images: [base64]
        }
        const res = await ImageSearchProductRequest(data);
        this.setState({ isLoading: false });
        if (res.Success == true) {
          let resultData = res.Data || [];
          this.setState({
            supplierProductList: resultData,
            isSupplierProductList: resultData.length == 0
          })
        }
        if(res.ErrorCode == 'TAOTE_AUTH_INVALID' || res.ErrorCode == 'ALIBABA_AUTH_EXPIRED'){
          this.state.needBindBuyerShop = res.ErrorCode;
          this.setState({})
          return;
        }
      })
    }, (e) => {
      this.setState({ isLoading: false});
      messageShow("图片地址无效", "info");
    })

  }

  /**图片压缩转换 */
  translateImgToBase64(url, rate, callback, err) {
    var that = this;
    var canvas = document.createElement('canvas')
    var context = canvas.getContext('2d')
    var img = new Image  //通过构造函数绘制图片实例
    img.crossOrigin = 'Anonymous'  //处理图片跨域问题
    img.onload = function () {   //该加载过程为异步事件，请先确保获取完整图片
      var targetWidth = img.width / rate;
      var targetHeight = img.height / rate;
      canvas.width = targetWidth;
      canvas.height = targetHeight;
      context.drawImage(img, 0, 0, img.width, img.height, 0, 0, targetWidth, targetHeight)
      var URLData = canvas.toDataURL('image/jpeg');
      var size = that.showSize(URLData);
      if (size > 300) {
        that.translateImgToBase64(URLData, rate, callback, err);
        return;
      }
      callback(URLData);
      canvas = null
    }
    if (err)
      img.onerror = err;
    img.src = url
  }
  showSize(base64url) {
    //把头部去掉
    var str = base64url.replace('data:image/png;base64,', '');
    // 找到等号，把等号也去掉
    var equalIndex = str.indexOf('=');
    if (str.indexOf('=') > 0) {
      str = str.substring(0, equalIndex);
    }
    // 原来的字符流大小，单位为字节
    var strLength = str.length;
    // 计算后得到的文件流大小，单位为字节
    var fileLength = parseInt(strLength - (strLength / 8) * 2);
    // 由字节转换为kb
    var size = "";
    size = (fileLength / 1024).toFixed(2);
    var sizeStr = size + ""; //转成字符串
    var index = sizeStr.indexOf("."); //获取小数点处的索引
    var dou = sizeStr.substr(index + 1, 2) //获取小数点后两位的值
    if (dou == "00") { //判断后两位是否为00，如果是则删除00                
      return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2)
    }
    return size;
  }

  loadSupplierProduct =async (productId,sourcePlatform,next)=>{
    let data = { }
    data.SupplierProductId = productId
    data.SourcePlatform = sourcePlatform
    this.setState({
      hasLoadBorder: true,
      noticeText: "正在抓取商品信息..",
      isShowLoadAction: true,
      isShowWarnText: false
    })
    const res = await loadSupplierProduct(data);
    
    this.setState({ isShowLoadAction: false });

    if (res.Success) {
      var supplierProduct = res.Data.AlibabaProduct;

      //遍历sku获取价格区间,供应商sku列表
      var priceArr = [];
      var supplierProductSkuList = [];
      for (let i = 0; i < supplierProduct.Skus.length; i++) {
        priceArr.push(supplierProduct.Skus[i].Price);
        var attrArr = JSON.parse(supplierProduct.Skus[i].Attributes);
        var color = '';
        var size = '';

        for (let n = 0; n < attrArr.length; n++) {
          if (n == 0) {
            color = attrArr[n].AttributeValue;
          } else {
            size = attrArr[n].AttributeValue;
          }
        }

        supplierProductSkuList.push({
          label: color + size,
          value: supplierProduct.Skus[i].SkuId
        });
      }
      priceArr.sort();


      var changeProduct = {
        ImageUrl: supplierProduct.Images[0],
        Subject: supplierProduct.Subject,
        PriceArr: priceArr,
        SupplyStock: supplierProduct.SupplyStock,
        Text: '',
        Status: supplierProduct.Status,
        SupplierLoginId: supplierProduct.SupplierLoginId,
        platformName: supplierProduct.SourcePlatform
      }

      this.setState({
        changeProduct: changeProduct,
        supplierProduct: supplierProduct,
        supplierProductSkuList: supplierProductSkuList,
        selectSupplierLoginId: supplierProduct.SupplierLoginId,
        selectSupplierProductId: supplierProduct.ProductId,
        selectSourcePlatform: supplierProduct.SourcePlatform
      }, () => {
        $(".changeProductsWrap .SupplierSkuList-item-select").each((index, item) => { //有默认值时 高亮显示
          if ($(item).val() != "") {
            $(item).addClass("active")
          }
        })
        this.relevanceProducFromChange()
      });
    } else {
      this.setState({
        noticeText: '非1688一件代发商品或当前商品需要通过厂家审核，请重新输入',
        isShowWarnText: true
      });
    }
  }

  inputTextareaByChangeProduct = () => {
    var setTimes = this.state.setTimes;
    if (setTimes != null) {
      clearTimeout(setTimes);
      this.setState({
        setTimes: setTimeout(() => { $("#textareaByChangeProductId").blur(); }, 1100)
      })
    }
    else {
      this.setState({
        setTimes: setTimeout(() => { $("#textareaByChangeProductId").blur(); }, 1100)
      })
    }

    this.setState({
      hideTTHelp: $('#textareaByChangeProductId').val().length > 0
    })

  }
  async loadSupplierProductByUrl(url) {
    var that = this;
    this.setState({
      changeProduct: null
    });

    if (url == null || url == '') {
      return;
    }
    var data = {};

    let supplierProducts = matchSupplierProduct(url);
    // if(systemConfig.isZk1() == false && systemConfig.isZk5() == false){
      //supplierProducts = supplierProducts.filter(x => x.sourcePlatform != 'TaoteZhuKe')
    // }
    if(supplierProducts.length == 0){
      messageShow('请输入正确格式的货源链接(例：https://detail.1688.com/offer/***.html或者商品ID)','error')
        that.setState({
          noticeText: '请输入正确格式的货源链接(例：https://detail.1688.com/offer/***.html或者商品ID)',
          isShowWarnText: true,
          // showNotFoundSupplierProductError:true,
        });
        return;
    }
    data.SupplierProductId = supplierProducts[0].supplierProductId
    data.SourcePlatform = supplierProducts[0].sourcePlatform

    that.setState({
      hasLoadBorder: true,
      noticeText: "正在抓取商品信息..",
      isShowLoadAction: true,
      isShowWarnText: false
    })
        
    if(supplierProducts[0].sourcePlatform == 'TaoteZhuKe' && !supplierProducts[0].supplierProductId){
        const matchTaoteLinkRequestData={ Links : [supplierProducts[0].link] }
        const res = await MatchTaoteLinkRequest(matchTaoteLinkRequestData)
        if(res.Success)
        {
            if(res.Data.List && res.Data.List.length > 0){
                data.SupplierProductId = res.Data.List[0].Item2
            }
        }
        if(!data.SupplierProductId){
            that.setState({
                noticeText: '淘口令已失效',
                isShowWarnText: true,
                showNotFoundSupplierProductError:true,
            });
            return;
        }
    }
    requests({
      url: "/Product/LoadSupplierProduct",
      data: data,
      success: function (res) {
        that.setState({ isShowLoadAction: false });


        if (res.Success) {
          var supplierProduct = res.Data.AlibabaProduct;

          //遍历sku获取价格区间,供应商sku列表
          var priceArr = [];
          var supplierProductSkuList = [];
          for (let i = 0; i < supplierProduct.Skus.length; i++) {
            priceArr.push(supplierProduct.Skus[i].Price);
            var attrArr = JSON.parse(supplierProduct.Skus[i].Attributes);
            var color = '';
            var size = '';

            for (let n = 0; n < attrArr.length; n++) {
              if (n == 0) {
                color = attrArr[n].AttributeValue;
              } else {
                size = attrArr[n].AttributeValue;
              }
            }

            supplierProductSkuList.push({
              label: color + size,
              value: supplierProduct.Skus[i].SkuId
            });
          }
          priceArr.sort();


          var changeProduct = {
            ImageUrl: supplierProduct.Images[0],
            Subject: supplierProduct.Subject,
            PriceArr: priceArr,
            SupplyStock: supplierProduct.SupplyStock,
            Text: '',
            Status: supplierProduct.Status,
            SupplierLoginId: supplierProduct.SupplierLoginId,
            platformName: supplierProduct.SourcePlatform
          }

          that.setState({
            changeProduct: changeProduct,
            supplierProduct: supplierProduct,
            supplierProductSkuList: supplierProductSkuList,
            selectSupplierLoginId: supplierProduct.SupplierLoginId,
            selectSupplierProductId: supplierProduct.ProductId,
            selectSourcePlatform: supplierProduct.SourcePlatform
          }, () => {
            $(".changeProductsWrap .SupplierSkuList-item-select").each((index, item) => { //有默认值时 高亮显示
              if ($(item).val() != "") {
                $(item).addClass("active")
              }
            })
          });
        } else {
          that.setState({
            noticeText: '非1688一件代发商品或当前商品需要通过厂家审核，请重新输入',
            isShowWarnText: true,
            showNotFoundAlibabaSupplierProductError:supplierProducts[0].sourcePlatform != 'TaoteZhuKe',
            showNotFoundSupplierProductError:supplierProducts[0].sourcePlatform == 'TaoteZhuKe',
          });
        }
      },
    });
  }
  relevanceProducFromChange = (item) => {
    var that = this;
    if (this.state.changeProduct == null) {
      messageShow("未获取到货源商品信息，请输入正确格式的货源链接", "warning");
      return;
    }

    this.setState({
      changeStatus: 'second',
    });
  }
  //上一步
  previousChangeProduct = (type) => {
    this.setState({
      [type]: 'first',
      // selectProduct: null,
      changeWidth: 900
    });
  }

  //确认关联，保存按钮
  sureRelevanceRequest = (isSomething,confirm) => {
    if(this.state.isTempRelevanceProduct == 1 && !confirm){
      this.setState({ isOnlyOrderDialog : true},()=>{
        $('input[name=only_order][value=1]').prop('checked',true)
      });
      return
    }

    var selectProduct = this.state.selectProduct;
    var supplierProduct = this.state.supplierProduct;
    var selectSourcePlatform = this.state.selectSourcePlatform;
    var skuMappingList = [];
    var skuList = selectProduct.Skus;

    for (let i = 0; i < skuList.length; i++) {
      if (skuList[i].SupplierSkuList == undefined || skuList[i].SupplierSkuList == null || skuList[i].SupplierSkuList[0].SupplierSkuId == "") {
        continue;
      }

      for (let n = 0; n < skuList[i].SupplierSkuList.length; n++) {
        if (skuList[i].SupplierSkuList[n].SupplierSkuId == undefined || skuList[i].SupplierSkuList[n].SupplierSkuId == null ||
          skuList[i].SupplierSkuList[n].SupplierSkuId == "" || skuList[i].SupplierSkuList[n].MappingCount <= 0) {
          continue;
        }

        skuMappingList.push({
          SkuId: skuList[i].SkuId,
          SupplierSkuId: skuList[i].SupplierSkuList[n].SupplierSkuId,
          MappingCount: skuList[i].SupplierSkuList[n].MappingCount
        });
      }
    }

    //判断
    if (skuMappingList.length <= 0) {
      messageShow("供应商规不能全部为空", "warning");
      return false;
    }

    var dataJson = {
      SupplierProductId: supplierProduct.ProductId,
      SupplierMemberId: '',
      SourcePlatform: supplierProduct.SourcePlatform,
      SupplierLoginId: supplierProduct.SupplierLoginId,
      ProductId: selectProduct.PlatformId,
      TargetShopId: this.state.TargetShopId,
      SkuMappings: skuMappingList,
      TargetShopPt: this.state.TargetShopPt,
    }

    if (this.state.productTag)
      dataJson.ProductTag = this.state.productTag;
    if(this.state.isTempRelevanceProduct == 1 && confirm)
      dataJson.ClearOrderTempDistribution = 1;

    var that = this;
    that.setState({ isLoading: true, loadingTitle: '保存中...' });
    requests({
      url: "/BatchDistribution/RelateProduct",
      data: dataJson,
      success: (res) => {
        that.setState({ isLoading: false, supplierProductList: [], isSupplierProductList: false });
        if (res.Success) {

          //确定关联按钮 传给父组件
          let obj = {};
          obj.selectProduct = selectProduct;
          obj.supplierProduct = supplierProduct;
          obj.tempPlatformOrderId = this.state.tempPlatformOrderId;
          
          //that.setState({ isShowChangeProduct: false, isRelevanceModal: false, isShowDailog: false });//, relateSucessDailogShow: true 
          messageShow("关联成功，可到代销商品中查看。", 'success');
          this.closeShowModal();
          this.props.sureRelevanceRequest(obj);


        } else {
          messageShow("关联货源失败:" + res.Message, "error");
        }


      },
      fail: function (error) {
        //console.log("aabb")
        that.setState({ isLoading: false });
      }
    });
  }

  //关闭确认更换货源弹窗
  closeConfrimChangeProduct = () => {
    this.setState({
      confrimChangeProduct: false,
      supplierProductList: [],
      isSupplierProductList: false,
    });
  }

  //关闭确认更换货源弹窗
  closeChangeProduct = (type) => {
    this.setState({
      supplierProductList: [],
      isSupplierProductList: false,
      isShowChangeProduct: false,
      isShowDailog: false,
      changeWidth: 900,
      changeStatus: 'first',//找关联货源 步骤
      changeSameProductStatus: 'first',//找同款 步骤
      selectProduct: null,
      // supplierProduct:null,
      changeProduct: null,
      isOnlyOrderDialog:false,
      tempOrderCode:null,
      tempOrderItemCode:null,
      tempPlatformOrderId:null,
      isTempRelevanceProduct:false,
      // selectedShopProduct: null,
      // supplierProductSkuList:null
    });
    this.props.closeChangeProductsModule();
  }

  closeShowModal = () => {
    this.setState({ isShowDailog: false, changeStatus: 'first', changeSameProductStatus: 'first', supplierProductList: [], isSupplierProductList: false });
    this.props.closeChangeProductsModule();
  }

  //下拉  选中事件
  selectSupplierProduct = (e, skuId, index) => {

    var tarEle = e.target;
    if (tarEle.value != "") {
      $(tarEle).addClass("active")
    } else {
      $(tarEle).removeClass("active")
    }
    var supplierSkuId = e.target.parentNode.childNodes[0].selectedOptions[0].value;
    var supplierSkuName = e.target.parentNode.childNodes[0].selectedOptions[0].text;
    var mappingCount = e.target.parentNode.childNodes[1].value;

    if (mappingCount != null && mappingCount != '') {
      if (!(/(^[1-9]\d*$)/.test(mappingCount))) {
        messageShow("数量必须填正整数的", "warning");
        return false;
      }
    }

    var selectProduct = this.state.selectProduct;
    var skuList = selectProduct.Skus;
    //商品
    for (let i = 0; i < skuList.length; i++) {
      if (skuId == skuList[i].SkuId) {
        if (skuList[i].SupplierSkuList == null || skuList[i].SupplierSkuList.length == 0) {
          skuList[i].SupplierSkuList = [];
          skuList[i].SupplierSkuList.push({
            SupplierSkuId: supplierSkuId,
            SupplierSkuName: supplierSkuName,
            MappingCount: 1,
            checked:true,//标识用户选择的，用于临时保存货源或者临时更换规格筛选使用
          });
        }
        else {
          for (let n = 0; n < skuList[i].SupplierSkuList.length; n++) {
            if (skuList[i].SupplierSkuList[n].SupplierSkuId == supplierSkuId && n != index) {
              messageShow("该供应商规格在组合中已存在！", "warning");
              e.target.selectedIndex = 0;
              skuList[i].SupplierSkuList.splice(index, 1);
              return false;
            }
          }

          skuList[i].SupplierSkuList[index].SupplierSkuId = supplierSkuId;
          skuList[i].SupplierSkuList[index].SupplierSkuName = supplierSkuName;
          skuList[i].SupplierSkuList[index].MappingCount = mappingCount;
          skuList[i].SupplierSkuList[index].checked = true;

          if (supplierSkuId == undefined || supplierSkuId == null || supplierSkuId == '') {
            messageShow("规格不能选择空，当前选择是无效的！", "warning");
            return false;
          }
        }
      }
    }
    selectProduct.Skus = skuList;
    this.setState({ selectProduct: selectProduct })
  }


  //规格型号 删除规格
  deleteSupplierProductSku = (e, skuId, index) => {
    var selectProduct = this.state.selectProduct;
    var skuList = selectProduct.Skus;

    for (let i = 0; i < skuList.length; i++) {
      if (skuList[i].SkuId == skuId) {
        skuList[i].SupplierSkuList.splice(index, 1);
      }
    }

    selectProduct.Skus = skuList;
    this.setState({ selectProduct: selectProduct })
  }

  //规格型号 添加规格
  addSupplierProductSku = (e, skuId) => {
    var selectProduct = this.state.selectProduct;
    var skuList = selectProduct.Skus;
    //商品
    for (let i = 0; i < skuList.length; i++) {
      if (skuId == skuList[i].SkuId) {
        if (skuList[i].SupplierSkuList == null) {
          skuList[i].SupplierSkuList = [];
          skuList[i].SupplierSkuList.push({
            SupplierSkuId: '',
            SupplierSkuName: '',
            MappingCount: 1
          });
        }

        skuList[i].SupplierSkuList.push({
          SupplierSkuId: '',
          SupplierSkuName: '',
          MappingCount: 1
        });
      }
    }
    selectProduct.Skus = skuList;

    this.setState({ selectProduct: selectProduct })
  }

  //规格型号 删除规格
  deleteSupplierProductSku = (e, skuId, index) => {
    var selectProduct = this.state.selectProduct;
    var skuList = selectProduct.Skus;

    for (let i = 0; i < skuList.length; i++) {
      if (skuList[i].SkuId == skuId) {
        skuList[i].SupplierSkuList.splice(index, 1);
      }
    }

    selectProduct.Skus = skuList;
    this.setState({ selectProduct: selectProduct })
  }

  orderbyChange = (sortName) => {
    let sortType = this.state[sortName] == 0 ? 1 : 0;
    $("#" + sortName).removeClass("active1").removeClass("active0").addClass("active" + sortType);
    this.setState({ [sortName]: sortType });
    let supplierProductList = this.state.supplierProductList;

    if (sortName == "minPriceSort") {
      if (sortType == 0) {
        supplierProductList = supplierProductList.sort(function (a, b) { return b['Price'] - a['Price']; });
      } else {
        supplierProductList = supplierProductList.sort(function (a, b) { return a['Price'] - b['Price']; });
      }
    }
    this.setState({
      supplierProductList
    })

  }

  toMyAuthPage(errorCode){
    let fromaction;
    if(errorCode == 'ALIBABA_AUTH_EXPIRED')
    {
        fromaction = 'alibaba_auth_expire'
    }
    else if(errorCode == 'TAOTE_AUTH_INVALID')
    {
        fromaction = 'taote_auth_expire'
    }
    const path = { pathname: '/myAuth', state: { from_action: fromaction } }
    this.props.history.push(path);
  }

  chooseMapProductSku = async (item) => {
    const hasTaoteSupplierProduct = !systemConfig.zhukeTaoteAuth && item.SourcePlatform == 'TaoteZhuKe';
    const hasAliSupplierProduct = !systemConfig.zhukeAlibabaAuth && (item.SourcePlatform == 'AlibabaZhuKe' || !item.SourcePlatform);
    if(hasAliSupplierProduct){
        this.sourcePlatformAuthDailog('AlibabaZhuKe');
        return;
    }
    else if(hasTaoteSupplierProduct){
        this.sourcePlatformAuthDailog('TaoteZhuKe');
        return;
    }
    this.setState({
      changeSameProduct: null,
      isLoading: true,
      loadingTitle: '获取商品详情中...',
    })
    // await this.getSelectProductInfo();
    await this.getSelectSupplierProductInfo(item);//获取同款商品详情
    this.setState({
      isLoading: false,
      loadingTitle: '',
    })

  }
  /**淘特授权过期跳转对话框 */
  sourcePlatformAuthDailog = async (sourcePlatform)=>{
    let str = '1688和淘特'
    let fromaction;
    if(sourcePlatform == 'AlibabaZhuKe'){
        str = '1688'
        fromaction = 'alibaba_auth_expire'
    }else if(sourcePlatform == 'TaoteZhuKe'){
        str = '淘特'
        fromaction = 'taote_auth_expire'
    }
    console.log('this =>',this);
    const action = await MessageBox.msgbox({
        title: '授权提示',
        message: <span>当前操作需要获得<span style={{ color: "#fa1f07", "fontSize": "16px" }}>{str}货源授权</span>，您未获得{str}授权或者授权失效，请先进行授权</span>,
        type: 'info',
        showCancelButton: false,
        confirmButtonText: '去授权'
    })
    if (action == 'confirm') {
        const path = { pathname: '/myAuth', state: { from_action: fromaction } }
        console.log('this =>',this);
        this.props.history.push(path);
    }
  }

  getSelectProductInfo = () => {
    return new Promise((resolve, reject) => {
      var that = this;
      this.setState({
        selectProduct: null,
        noticeText: '获取信息中...',
      });

      var data = {
        ShopId: that.state.TargetShopId,
        ProductId: that.state.selectProductId
      };

      requests({
        url: "/Product/LoadProductAndSupplierProductSku",
        data: data,
        success: function (res) {
          console.log("resresres", res)

          if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
          {
            that.setState({ noticeText: '请求超时，请重试。' });
            return;
          }
          that.setState({ noticeText: '' });
          if (res.Success) {
            var product = res.Data.ProductFx;


            var priceArr = [];
            for (let i = 0; i < product.Skus.length; i++) {
              priceArr.push(product.Skus[i].SalePrice);
              product.Skus[i].SupplierSkuList = null;
            }
            priceArr.sort();
            product.PriceArr = priceArr;
            that.setState({
              selectProduct: product,
              selectPlatformTypeRelevance: product.PlatformType
            }, () => {
              resolve(true);
            });
          } else {
            messageShow("获取商品信息失败" + res.Message, "error");
          }
        },
      });

    })
  }
  //临时更换产品规格
  changeTemporaryRelation = () => {
    var data = {
      ShopId: this.state.TargetShopId,
      ProductId: this.state.selectProductId,
      IsTemporarySearch: this.state.isTempRelevanceProduct || null,
      PlatformOrderId: this.state.tempPlatformOrderId
    };
    this.setState({
      isLoading: true, loadingTitle: '获取信息中...',
    });
    var that = this;

    requests({
      url: "/Product/LoadProductSkuMapping",
      data: data,
      success: (res) => {
        that.setState({ isLoading: false, noticeText: '' });
        if (res.Success) {
          var product = res.Data.ProductFx;
          var skuList = res.Data.AlibabaProductSku;

          for (let i = 0; i < product.Skus.length; i++) {
            //如果发现后台返回值的mappingcount为0，改为1
            if (product.Skus[i].SupplierSkuList != null) {
              for (let n = 0; n < product.Skus[i].SupplierSkuList.length; n++) {
                if (product.Skus[i].SupplierSkuList[n].MappingCount == null || product.Skus[i].SupplierSkuList[n].MappingCount == 0) {
                  product.Skus[i].SupplierSkuList[n].MappingCount = 1;
                }
              }
            } else if (product.Skus[i].SupplierSkuId != null && product.Skus[i].SupplierSkuId > 0) {
              product.Skus[i].SupplierSkuList = [];
              product.Skus[i].SupplierSkuList.push({
                SupplierSkuId: product.Skus[i].SupplierSkuId,
                SupplierSkuName: product.Skus[i].SupplierSkuName,
                MappingCount: 1
              });
            }
          }
          
          that.setState({
            selectProduct: product,
            selectPlatformTypeRelevance: product.PlatformType,
          },()=>{
            if(skuList && skuList.length > 0){
              var supplierProductId = skuList[0].ProductId;
              var sourcePlatform = res.Data.SourcePlatform;
              this.loadSupplierProduct(supplierProductId,sourcePlatform);
            }
          });
        } else {
          messageShow("错误信息：" + res.Message, "error");
        }
      },
      fail: (err) => { }
    })
  }

  getSelectSupplierProductInfo = (item) => {

    return new Promise((resovle, reject) => {
      var that = this;
      var data = {
        SupplierProductId: item.ProductId,
        SourcePlatform: item.SourcePlatform
      };

      requests({
        url: "/Product/LoadSupplierProduct",
        data: data,
        success: function (res) {
          that.setState({ isShowLoadAction: false,isLoading: false,});

          if (res.Success) {
            var supplierProduct = res.Data.AlibabaProduct;

            //遍历sku获取价格区间,供应商sku列表
            var priceArr = [];
            var supplierProductSkuList = [];
            for (let i = 0; i < supplierProduct.Skus.length; i++) {
              priceArr.push(supplierProduct.Skus[i].Price);
              var attrArr = JSON.parse(supplierProduct.Skus[i].Attributes);
              var color = '';
              var size = '';

              for (let n = 0; n < attrArr.length; n++) {
                if (n == 0) {
                  color = attrArr[n].AttributeValue;
                } else {
                  size = attrArr[n].AttributeValue;
                }
              }

              supplierProductSkuList.push({
                label: color + size,
                value: supplierProduct.Skus[i].SkuId
              });
            }
            priceArr.sort();

            var changeProduct = {
              ImageUrl: supplierProduct.Images[0],
              Subject: supplierProduct.Subject,
              PriceArr: priceArr,
              SupplyStock: supplierProduct.SupplyStock,
              Text: '',
              Status: supplierProduct.Status,
              SupplierLoginId: supplierProduct.SupplierLoginId,
              platformName: supplierProduct.SourcePlatform,
            }

            that.setState({
              changeSameProduct: changeProduct,
              supplierProduct: supplierProduct,
              supplierProductSkuList: supplierProductSkuList,
              selectSupplierLoginId: supplierProduct.SupplierLoginId,
              selectSupplierProductId: supplierProduct.ProductId,
              changeSameProductStatus: 'second',

            }, () => {
              resovle(true);
              $(".changeProductsWrap .SupplierSkuList-item-select").each((index, item) => { //有默认值时 高亮显示
                if ($(item).val() != "") {
                  $(item).addClass("active")
                }
              })
            });
          } else {
            // messageShow("错误信息：" + res.Message,'error');
            that.setState({
              noticeText: '非1688一件代发商品或当前商品需要通过厂家审核，请重新输入',
              isShowWarnText: true,
              showNotFoundAlibabaSupplierProductError:item.SourcePlatform != 'TaoteZhuKe',
              showNotFoundSupplierProductError:item.SourcePlatform == 'TaoteZhuKe',
            });
          }
        },
      });

    })
  }

  huoyuanLink = (item) => {
    var url = "https://detail.1688.com/offer/" + item.ProductId + ".html";
    if (item.SourcePlatform == 'TaoteZhuKe') {
      var url = 'https://market.m.taobao.com/app/nozomi/app-h5-detail/main/index.html?id=' + item.ProductId
    }
    window.open(url, "_blank");
  }

  //确认关联操作，保存(临时更换货源)
  sureTempRelevanceRequest = (isSomething) => {

    var selectProduct = this.state.selectProduct;
    var supplierProduct = this.state.supplierProduct;

    var selectSupplierLoginId = supplierProduct.SupplierLoginId;
    var selectSupplierProductId = supplierProduct.ProductId;
    var selectSourcePlatform = supplierProduct.SourcePlatform;


    var selectShopPlatformType = this.state.TargetShopPt;
    var tempPlatformOrderId = this.state.tempPlatformOrderId;
    var tempOrderCode = this.state.tempOrderCode;
    var tempOrderItemCode = this.state.tempOrderItemCode;

    var skuMappingList = [];
    var skuList = selectProduct.Skus;
    for (let i = 0; i < skuList.length; i++) {
      if (skuList[i].SupplierSkuList == undefined || skuList[i].SupplierSkuList == null || skuList[i].SupplierSkuList[0].SupplierSkuId == "") {
        continue;
      }

      for (let n = 0; n < skuList[i].SupplierSkuList.length; n++) {
        if (skuList[i].SupplierSkuList[n].SupplierSkuId == undefined || skuList[i].SupplierSkuList[n].SupplierSkuId == null ||
          skuList[i].SupplierSkuList[n].SupplierSkuId == "" || skuList[i].SupplierSkuList[n].MappingCount <= 0) {
          continue;
        }
        if(!skuList[i].SupplierSkuList[n].checked)//用户选择的规格映射
          continue;

        skuMappingList.push({
          SkuId: skuList[i].SkuId,
          SupplierSkuId: skuList[i].SupplierSkuList[n].SupplierSkuId,
          MappingCount: skuList[i].SupplierSkuList[n].MappingCount,
          PlatformOrderId: tempPlatformOrderId,
          OrderCode: tempOrderCode,
          OrderItemCode: tempOrderItemCode,
        });
      }
    }

    let item = {};
    item.selectProduct = selectProduct;
    item.supplierProduct = supplierProduct;
    item.tempPlatformOrderId = this.state.tempPlatformOrderId;
    item.isOnlyOrder = true
    //判断
    if (skuMappingList.length <= 0) {
      this.closeShowModal();
      messageShow("重新映射成功。", "success");
      this.props.sureRelevanceRequest(item);
      // messageShow("供应商规不能全部为空","warning");
      return false;
    }

    var dataJson = {
      SupplierProductId: selectSupplierProductId,
      SourcePlatform: selectSourcePlatform,
      SupplierMemberId: '',
      SupplierLoginId: selectSupplierLoginId,
      ProductId: selectProduct.PlatformId,
      TargetShopId: selectProduct.ShopId,
      SkuMappings: skuMappingList,
      TargetShopPt: selectShopPlatformType,
    }

    this.setState({ isLoading: true, loadingTitle: '保存中...' });
    var that = this;

    requests({
      url: "/PurchaseOrder/RelateTemporaryProduct",
      data: dataJson,
      success: (res) => {
        that.setState({ isLoading: false, supplierProductList: [], isSupplierProductList: false });
        if (res.Success) {
          that.closeShowModal();
          // that.setState({ isShowChangeProduct: false, isRelevanceModal: false, isShowDailog: false });//, relateSucessDailogShow: true 
          messageShow("重新映射成功。", "success");
          that.props.sureRelevanceRequest(item);
        } else {
          messageShow("关联货源失败:" + res.Message, "error");
        }
      },
      fail: function (error) {
        //console.log("aabb")
        that.setState({ isLoading: false });
      }
    })

    
  }

  choiceRelevanceRequest(){
    var isonlyOrder = $("input[name=only_order]:checked").val()
    this.setState({ isOnlyOrderDialog: false})
    if(isonlyOrder == 1){
      this.sureTempRelevanceRequest()
    }else if(isonlyOrder == 0)
    {
      this.sureRelevanceRequest(false,true)
    }
  }

  //渲染商品sku映射html
  mapProductSkuHtml = (changeProduct) => {
    return (
      <div>
        <div className='second-SkuMapWrap-top'>
          <div className="dailogSkuMapWrap-up">
            {

              <div>
                <div className="dailogSkuMapWrap-up-title">
                  <span>已关联{getPlatformName(this.state.selectPlatformTypeRelevance)}的商品</span>
                </div>
                <div className="dailogSkuMapWrap-up-main">
                  <div className="productShow table-product">
                    <div className="productShow-imgWrap">
                      {
                        this.state.selectProduct != null ?
                          <img src={this.state.selectProduct.ImageUrl == null || this.state.selectProduct.ImageUrl == "" ? this.state.selectProduct.PicURI ? this.state.selectProduct.PicURI : "" : this.state.selectProduct.ImageUrl} alt="" />
                          : null
                      }

                    </div>
                    <ul>
                      <li title="商品标题">{this.state.selectProduct == null ? "" : this.state.selectProduct.Subject}</li>
                      <li className='dangerColor'>售价：￥{this.state.selectProduct == null || this.state.selectProduct.PriceArr == null ? "" : this.state.selectProduct.PriceArr[0]}起</li>
                    </ul>
                  </div>
                </div>
              </div>
            }
          </div>
          <div className='dailogSkuMapWrap-mid'>
            <span>对应货源</span>
            <i className='iconfont icon-fanhuidingbu'></i>
          </div>
          <div className="dailogSkuMapWrap-up">
            <div className="dailogSkuMapWrap-up-title">
              <span>已关联{this.state[changeProduct] == null ? "" : this.state[changeProduct].platformName == "TaoteZhuKe" ? "淘特" : "1688"}的商品</span>
            </div>
            <div className="dailogSkuMapWrap-up-main">
              <div className="productShow table-product">
                <div className="productShow-imgWrap">
                  {
                    this.state[changeProduct] != null ?
                      <img src={this.state[changeProduct].ImageUrl == null || this.state[changeProduct].ImageUrl == "" ? this.state[changeProduct].PicURI ? this.state[changeProduct].PicURI : "" : this.state[changeProduct].ImageUrl} alt="" />
                      : null
                  }
                </div>
                <ul>
                  <li title="商品标题">{this.state[changeProduct] == null ? "" : this.state[changeProduct].Subject}</li>
                  <li className='dangerColor'>进货价：￥{this.state[changeProduct] == null || this.state[changeProduct].PriceArr == null ? "" : this.state[changeProduct].PriceArr[0]}起</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="dailogSkuMapWrap-down">
          <table className="table-style01">
            <thead>
              <tr>
                <th style={{ width: "350px" }}>{getPlatformName(this.state.selectPlatformTypeRelevance)}规格信息</th>
                <th style={{ width: "410px" }}>产品信息</th>
                <th style={{ width: "90px" }}>操作</th>
              </tr>
            </thead>
            <tbody>
              {
                this.state.selectProduct == null || this.state.selectProduct.Skus.length == 0 ?
                  <tr><td colSpan="2">没有规格信息</td></tr> :
                  this.state.selectProduct.Skus
                  .filter(x => !this.state.selectProductSkuId || x.SkuId == this.state.selectProductSkuId)
                  .map((item, index) =>
                    <tr>
                      <td>{item.AttributeValue1}{item.AttributeValue2}</td>
                      {
                        item.SupplierSkuList != null && item.SupplierSkuList.length > 0 ?
                          <td>
                            {
                              item.SupplierSkuList.map((supItem, index) =>
                                <div className='SupplierSkuList-item'>
                                  <select className='SupplierSkuList-item-select' onChange={(e) => this.selectSupplierProduct(e, item.SkuId, index)}>
                                    <option value="">请选择</option>:
                                    {
                                      this.state.supplierProductSkuList.map((item02, index02) =>
                                        supItem.SupplierSkuId == item02.value ?
                                          <option value={item02.value} index={index02} selected>{item02.label}</option> :
                                          <option value={item02.value} index={index02}>{item02.label}</option>
                                      )
                                    }
                                  </select>
                                  <input type='number' value={supItem.MappingCount} onChange={(e) => this.selectSupplierProduct(e, item.SkuId, index)}></input>
                                  {
                                    item.SupplierSkuList.length > 1 ?
                                      <span className='dangerColor' onClick={(e) => this.deleteSupplierProductSku(e, item.SkuId, index)}>删除</span> :
                                      null
                                  }
                                </div>
                              )
                            }
                          </td> :
                          <td>
                            <div className='SupplierSkuList-item'>
                              <select className='SupplierSkuList-item-select' onChange={(e) => this.selectSupplierProduct(e, item.SkuId, 0)}>
                                <option value="">请选择</option>:
                                {
                                  this.state.supplierProductSkuList.map((item02, index) =>
                                    item.SupplierSkuId == item02.value ?
                                      <option value={item02.value} index={index} selected>{item02.label}</option> :
                                      <option value={item02.value} index={index}>{item02.label}</option>
                                  )
                                }
                              </select>
                              <input type='number' onChange={(e) => this.selectSupplierProduct(e, item.SkuId, 0)}></input>
                            </div>
                          </td>
                      }
                      <td><span className='defColor hover' onClick={(e) => this.addSupplierProductSku(e, item.SkuId)}>添加规格</span></td>
                    </tr>
                  )
              }
            </tbody>
          </table>
        </div>
      </div>

    )

  }
  closeNotFoundAlibabaSupplierProductErrorDailog(){
    this.state.showNotFoundSupplierProductError = false
    this.state.showNotFoundAlibabaSupplierProductError = false
    this.setState({ })
  }


  render() {
    return (
      <ShowModal
        showLeftTopBtn={true}
        width={900}
        showModal={this.state.isShowDailog}
        titleName={this.state.title}
        skin={"changeProductsWrap"}
        hideBtn={true}
        cancelDailog={this.closeShowModal} //取消按钮回调函数

      >

        <div className="showModalWrap-box-commonContent changeProductsWrap-commonContent scroll-x">
          <div className="showModalWrap-commonContent-item">
            {/* {
              this.state.activeId == 0 ?
                <div className='tagStatus tagWarn tagStatusWrap'>
                  <span>关联货源 <i className='iconfont icon-xiangxia'></i> 规格匹配 <i className='iconfont icon-xiangxia'></i> 订单自动回流采购</span>
                  <div className='iconfont icon-tips'>
                    <div className='icon-tips-content'>
                      <span>1、关联或更换货源时，注意货源的起批量，避免因起批量不足导致不能正常采购。</span>
                      <span>2、关联或更换货源后，请进行规格匹配，匹配后店铺商品被买家下单时，将会按您匹配的货源规格进行采购，并同步发货和物流信息;</span>
                      <span>3、您和供应商任意一方修改规格名/删除规格，都会导致匹配关系失效，需要重新进行匹配规格。</span>
                    </div>
                  </div>
                </div> :
                <div className='showModalWrap-commonContent-warn changeProductsWrap-warn' style={{ marginBottom: '15px' }}>
                  <div className="confirmComom-icon">!</div>
                  <ul>
                    <li>1、更换货源时，注意货源的起批量，避免因起批量不足导致不能正常采购。</li>
                    <li>2、更换货源成功后，当店铺商品被买家下单时会全部采购新货源，并同步发货和物流信息；</li>
                    <li>3、如想取消关联货源，可以到代销商品-代销中，找到商品并终止代销；</li>
                    <li>4、对于未进行映射货源的店铺商品规格，则不能正常采购。</li>
                    <li>5、您和供应商任意一方修改规格名/删除规格，都会导致匹配关系失效，需要重新进行匹配。</li>
                  </ul>
                </div>
            } */}
            <div className='tagStatus tagWarn tagStatusWrap'>
              <span style={{color:'#666'}}>关联货源 <i className='iconfont icon-xiangxia'></i> 规格匹配 <i className='iconfont icon-xiangxia'></i> 订单自动回流采购</span>
              <div className='iconfont icon-tips'>
                <div className='icon-tips-content' style={{marginTop:'-150px'}}>
                  <span>1、关联或更换货源时，注意货源的起批量，避免因起批量不足导致不能正常采购。</span>
                  <span>2、关联或更换货源后，请进行规格匹配，匹配后店铺商品被买家下单时，将会按您匹配的货源规格进行采购，并同步发货和物流信息;</span>
                  <span>3、您和供应商任意一方修改规格名/删除规格，都会导致匹配关系失效，需要重新进行匹配规格。</span>
                </div>
              </div>
            </div>
          </div>
          {
            this.state.activeId == 0 ?
              <div>
                <div style={{ padding: '10px 0', margin: '0 0 10px 0' }} className={this.state.changeStatus == 'second' ? 'showModalWrap-commonContent-item showModalWrapstepWrap showModalWrapstepWrapsecond' : "showModalWrap-commonContent-item showModalWrapstepWrap"}>
                  <div className='my-Steps'>
                    <div className={this.state.changeStatus == 'first' || this.state.changeStatus == 'second' ? 'my-Steps-item active' : 'my-Steps-item'}>
                      <span className='my-Steps-item-icon'>1</span>
                      <span className='my-Steps-item-text'>添加货源链接</span>
                      <span className='my-Steps-item-line'></span>
                    </div>
                    <div className={this.state.changeStatus == 'second' ? 'my-Steps-item active' : 'my-Steps-item'}>
                      <span className='my-Steps-item-icon'>2</span>
                      <span className='my-Steps-item-text'>映射货源规格</span>
                    </div>
                  </div>
                </div>

                {
                  this.state.changeStatus == 'first'? 
                  <div className='tagProductWrap'>
                    <div className='tagProductWrap-title'>
                      <span>店铺商品ID：</span>
                      <span>{this.state.selectProduct == null ? "" : this.state.selectProduct.PlatformId}</span>
                    </div>
                    <div className="productShow table-product">
                      <div className="productShow-imgWrap">
                        <img src={this.state.selectProduct == null ? "" : this.state.selectProduct.ImageUrl ? this.state.selectProduct.ImageUrl : this.state.selectProduct.PicURI ? this.state.selectProduct.PicURI : ''} alt="" />
                      </div>
                      <ul>
                        <li title="商品标题">
                          <span>{this.state.selectProduct == null ? "" : this.state.selectProduct.Subject}</span>
                        </li>
                        <li title="价格">
                          <span className='dangerColor'>售价：￥{this.state.selectProduct == null || this.state.selectProduct.PriceArr == null ? "" : this.state.selectProduct.PriceArr[0]}起</span>
                        </li>
                      </ul>
                    </div>
                  </div>:null
                }
                


              </div>
              :
              <div>
                <div style={{ padding: '10px 0', margin: '0 0 10px 0' }} className={this.state.changeSameProductStatus == 'second' ? 'showModalWrap-commonContent-item showModalWrapstepWrap showModalWrapstepWrapsecond' : "showModalWrap-commonContent-item showModalWrapstepWrap"}>
                  <div className='my-Steps'>
                    <div className={this.state.changeSameProductStatus == 'first' || this.state.changeSameProductStatus == 'second' ? 'my-Steps-item active' : 'my-Steps-item'}>
                      <span className='my-Steps-item-icon'>1</span>
                      <span className='my-Steps-item-text'>关联货源</span>
                      <span className='my-Steps-item-line'></span>
                    </div>
                    <div className={this.state.changeSameProductStatus == 'second' ? 'my-Steps-item active' : 'my-Steps-item'}>
                      <span className='my-Steps-item-icon'>2</span>
                      <span className='my-Steps-item-text'>映射货源规格</span>
                    </div>
                  </div>
                </div>
                {
                  this.state.changeSameProductStatus == 'first'? 
                  <div className='tagProductWrap'>
                    <div className='tagProductWrap-title'>
                      <span>店铺商品ID：</span>
                      <span>{this.state.selectProduct == null ? "" : this.state.selectProduct.PlatformId}</span>
                    </div>
                    <div className="productShow table-product">
                      <div className="productShow-imgWrap">
                        <img src={this.state.selectProduct == null ? "" : this.state.selectProduct.ImageUrl ? this.state.selectProduct.ImageUrl : this.state.selectProduct.PicURI ? this.state.selectProduct.PicURI : ''} alt="" />
                      </div>
                      <ul>
                        <li title="商品标题">
                          <span>{this.state.selectProduct == null ? "" : this.state.selectProduct.Subject}</span>
                        </li>
                        <li title="价格">
                          <span className='dangerColor'>售价：￥{this.state.selectProduct == null || this.state.selectProduct.PriceArr == null ? "" : this.state.selectProduct.PriceArr[0]}起</span>
                        </li>
                      </ul>
                    </div>
                  </div>:null
                }
              </div>

          }
          {
             (this.state.activeId == 0 && this.state.changeStatus == "first") || (this.state.activeId == 1 && this.state.changeSameProductStatus == "first") ?
              <TableNavChange distributionStatus={this.state.changeSearchNavs} noShowNum={true} changeNav={this.changeNav} />:null
          }
          {
            this.state.activeId == 0 ?
              <div>
                <div>
                  <div style={this.state.changeStatus == 'first' ? { display: 'inline' } : { display: 'none' }}>
                    {
                      // systemConfig.isZk1() || systemConfig.isZk5() ?
                      <div className="showModalWrap-commonContent-item" style={{ position: 'relative' }}>
                        <textarea className='link-textarea' placeholder='请输入1688货源链接' id="textareaByChangeProductId" style={{ overflow: "hidden", width: "100%", padding: "5px", height: '50px' }} onInput={() => this.inputTextareaByChangeProduct()} onBlur={(e) => this.loadSupplierProductByUrl(e.target.value)}></textarea>
                        {/* {
                          !this.state.hideTTHelp ?
                            <a className='showModalWrap-help' href='https://docs.qq.com/doc/DYm5seUFNaFdPZ1ls' target='_blank'>如何获取淘特口令上货？</a> : null
                        } */}
                      </div>
                      // :<div className="showModalWrap-commonContent-item" style={{ position: 'relative' }}>
                      //   <textarea className='link-textarea' placeholder='请输入1688货源链接' id="textareaByChangeProductId" style={{ overflow: "hidden", width: "100%", padding: "5px", height: '50px' }} onInput={() => this.inputTextareaByChangeProduct()} onBlur={(e) => this.loadSupplierProductByUrl(e.target.value)}></textarea>
                      // </div>
                    }
                    
                    {/* <div className="showModalWrap-commonContent-item showModalWrap-commonContent-loadWrap" style={this.state.isShowWarnText ? { display: 'flex' } : { display: 'none' }}>
                      <div style={this.state.isShowLoadAction ? { display: 'inline' } : { display: 'none' }}><span className='loadmore'></span></div>
                      {
                        this.state.isShowWarnText ?
                          <div className='noticeText'>
                            <i className='iconfont icon-shanchu dangerColor'></i>{this.state.noticeText}</div> :
                          <span className='noticeText02'>{this.state.noticeText}</span>
                      }
                    </div> */}
                    <div className='platformWrap' style={this.state.changeProduct == null ? { display: 'flex'} : { display: 'none' }}>
                      <span>支持平台：</span>
                      <PlatformName platformType={'Alibaba'} iconSize={"smallIcon"} />
                      {
                        // <PlatformName platformType={'Taote'} iconSize={"smallIcon"} />
                      }
                    </div>

                    <div className="showModalWrap-commonContent-item productShow showModalWrapProductShow" style={this.state.changeProduct != null ? { display: 'flex' } : { display: 'none' }}>
                      <span className='productShow-title'>货源信息</span>
                      <div className='productShow-content'>
                        <div className='productShow-content-img'>
                          <img src={this.state.changeProduct != null ? this.state.changeProduct.ImageUrl : ''}></img>
                        </div>
                        <ul className='productShow-content-sku'>
                        <li onClick={()=>{ this.huoyuanLink(this.state.supplierProduct)}} className='hover' style={{color:'#3aadff'}}>{this.state.changeProduct != null ? this.state.changeProduct.Subject : ''}</li>
                          <li className='dangerColor'>¥{this.state.changeProduct != null ? this.state.changeProduct.PriceArr[0] : ''}
                            ~{this.state.changeProduct != null ? this.state.changeProduct.PriceArr[this.state.changeProduct.PriceArr.length - 1] : ''}</li>
                          <li>库存：{this.state.changeProduct != null ? this.state.changeProduct.SupplyStock : ''}</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div style={this.state.changeStatus == 'second' ? { display: 'inline' } : { display: 'none' }}>
                    {
                      this.mapProductSkuHtml('changeProduct')
                    }
                  </div>
                </div>
                <div className="showModalWrap-box-commonfooter">
                  <div style={this.state.changeStatus == 'first' ? { display: 'flex' } : { display: 'none' }}>
                    <span style={this.state.changeProduct != null ? { cursor: "pointer", backgroundColor: "#5584ff", border: '1px solid #5584ff' } :
                      { cursor: "not-allowed", 'background-color': "#ccc", border: '1px solid #ccc' }}
                      onClick={() => this.relevanceProducFromChange()} className="showModalWrap-box-footer-btn">下一步</span>
                  </div>
                  <span style={this.state.changeStatus == 'second' ? { display: 'flex', marginRight: "5px" } : { display: 'none' }} onClick={() => this.previousChangeProduct('changeStatus')}
                    className="showModalWrap-box-footer-btn cancleBtn">上一步</span>
                  <span style={this.state.changeStatus == 'second' ? { display: 'flex' } : { display: 'none' }} onClick={() => this.sureRelevanceRequest()}
                    className="showModalWrap-box-footer-btn">确定关联</span>
                  <span onClick={() => this.closeChangeProduct('changeStatus')} className="showModalWrap-box-footer-btn cancleBtn">关闭</span>
                </div>
              </div>
              :
              <div className='syncProductWrap'>
                <div style={this.state.changeSameProductStatus == 'first' ? { display: 'block' } : { display: 'none' }}>
                  <table className="table02">
                    <thead>
                      <tr>
                        <th style={{ width: "600px"}}>
                          {/* <div onClick={() => this.orderbyChange('salesCntSort')} id="salesCntSort" className='operateWrap' style={{ justifyContent: 'flex-start' }}>
                            <span className='hover'>同款货源推荐销量从高到底</span>
                            <span className="ph-filtbar-down-leftBtns-icons">
                              <i className="icon-down-fill iconfont"></i>
                              <i className="icon-down-fill iconfont"></i>
                            </span>
                          </div> */}
                          <span>产品详情</span>
                          <div style={{ display:'inline-flex'}}>
                            {/* <div>
                              <input name="selectSourcePlatform" type="radio" value="" checked={!this.state.selectSourcePlatform ? true : false} onChange={(e) => this.getSupplierProductList()}></input>
                              <span>全部</span>
                            </div> */}
                            
                            <div>
                              <input name="selectSourcePlatform" type="radio" value="AlibabaZhuKe" checked={this.state.selectSourcePlatformNav == 'AlibabaZhuKe' ? true : false}  onChange={(e) => this.getSupplierProductList()}></input>
                              <span>1688</span>
                            </div>
                            
                            {/* <div>
                              <input name="selectSourcePlatform" type="radio" value="TaoteZhuKe"  checked={this.state.selectSourcePlatformNav == 'TaoteZhuKe' ? true : false}  onChange={(e) => this.getSupplierProductList()}></input>
                              <span>淘特</span>
                            </div> */}
                            
                            
                          </div>
                          
                        </th>
                        <th style={{ width: "120px" }}>
                          <div onClick={() => this.orderbyChange('minPriceSort')} id="minPriceSort" className='operateWrap'>
                            <span className='hover'>价格</span>
                            <span className="ph-filtbar-down-leftBtns-icons">
                              <i className="icon-down-fill iconfont"></i>
                              <i className="icon-down-fill iconfont"></i>
                            </span>
                          </div>
                        </th>
                        <th style={{ width: "120px" }}>操作</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        this.state.supplierProductList.map((item, index) =>
                          <tr key={index}>
                            <td>
                              <div className="productShow table-product">
                                <div className="productShow-imgWrap productShow-imgWrap-hover">
                                  <img src={item.PicImageUrl} alt="" />
                                </div>
                                <ul>
                                  <li title="商品标题">
                                    <span onClick={() => this.huoyuanLink(item)} className='defColor hover'>
                                      {item.Title}
                                    </span>
                                  </li>
                                  <li>
                                    <PlatformName platformType={item.SourcePlatform} iconSize={"tinyIcon"} />
                                  </li>
                                </ul>
                              </div>
                            </td>
                            <td>
                              <span className='dangerColor'>价格：￥{item.Price}</span>
                            </td>
                            <td>
                              <span className='defColor hover' onClick={() => this.chooseMapProductSku(item)}>选择</span>
                            </td>
                          </tr>
                        )
                      }
                      {
                        this.state.isSupplierProductList && !this.state.needBindBuyerShop ?
                          <tr>
                            <td className="noneData" colSpan="20">
                              <div className="noneData-wrap">
                                <i className="iconfont icon-wushuju"></i>
                                <span className="noneData-title">暂无同款数据！</span>
                              </div>
                            </td>
                          </tr> : null
                      }
                      {
                        this.state.needBindBuyerShop ?
                          <tr>
                            <td className="noneData" colSpan="20">
                              <div className="noneData-wrap">
                                <span className="noneData-title">当前操作需要获得<span style={{ color: "#fa1f07", "fontSize": "16px" }}>
                                    {this.state.needBindBuyerShop == 'TAOTE_AUTH_INVALID'  ? '淘特':'1688'}货源授权</span>，
                                    您未获得{this.state.needBindBuyerShop == 'TAOTE_AUTH_INVALID' ? '淘特':'1688'}授权或者授权失效，请先进行授权</span>
                                <div style={{ marginTop:'10px'}}>
                                    <span className="el-button el-button--primary" onClick={() => this.toMyAuthPage(this.state.needBindBuyerShop) }>前往授权</span>
                                </div>
                              </div>
                            </td>
                          </tr> : null
                      }
                    </tbody>
                  </table>
                </div>
                <div style={this.state.changeSameProductStatus == 'second' ? { display: 'inline' } : { display: 'none' }}>
                  {
                    this.mapProductSkuHtml('changeSameProduct')
                  }
                </div>
                <div className="showModalWrap-box-commonfooter">
                  <span style={this.state.changeSameProductStatus == 'second' ? { display: 'flex', marginRight: "5px" } : { display: 'none' }} onClick={() => this.previousChangeProduct('changeSameProductStatus')}
                    className="showModalWrap-box-footer-btn cancleBtn">上一步</span>
                  <span onClick={() => this.sureRelevanceRequest()} style={this.state.changeSameProductStatus == 'second' ? { display: 'flex' } : { display: 'none' }}
                    className="showModalWrap-box-footer-btn">确定关联</span>
                  <span onClick={() => this.closeChangeProduct('changeSameProductStatus')} className="showModalWrap-box-footer-btn cancleBtn">关闭</span>
                </div>
              </div>
          }
        </div>
        <ShowModal 
          titleName={'确定是否更换'}
          showLeftTopBtn={true}
          width={500}
          showModal={this.state.isOnlyOrderDialog}
          skin={"changeProductsWrap"}
          hideBtn={true}
          className={'isOnlyOrderDialogWarp'}
          cancelDailog={() => this.closeChangeProduct('isOnlyOrderDialog')} >
            <div className='isOnlyOrderDialogRadio showModalWrap-box-commonContent'>
              <div className='isOnlyOrderDialogRadioItem'>
                <input type="radio" name='only_order' value='1'/>
                <span>仅针对这笔订单</span>
                <div>
                  <span>不保存关联关系，下次下单还是使用原货源</span>
                </div>
              </div>
              <div className='isOnlyOrderDialogRadioItem'>
                <input type="radio" name='only_order' value='0'/>
                <span>此店铺商品产生的订单全部更换为新货源</span>
                <div>
                  <span>保存关联关系，下次下单全部使用新货源</span>
                </div>
              </div>
            </div>
            <div className="showModalWrap-box-commonfooter">
                  <span onClick={() => this.choiceRelevanceRequest()} style={{ display: 'flex' }}
                    className="showModalWrap-box-footer-btn">确定关联</span>
                  <span onClick={() => this.setState({isOnlyOrderDialog:false})} className="showModalWrap-box-footer-btn cancleBtn">关闭</span>
            </div>
        </ShowModal>

        <ShowModal showModal={this.state.showNotFoundSupplierProductError} titleName={"货源不支持铺货代发"} width={'450px'} cancelDailog={() => this.closeNotFoundAlibabaSupplierProductErrorDailog()} hideBtn={true} showLeftTopBtn={true}>
            <div style={{fontSize:'16px',padding:'10px',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center'}}>
                <div>
                    <span>该货源未获得分销授权，无法进行铺货、关联、更换。您可以换个货源或者联系供应商将该商品设置为支持分销</span>
                </div>
            </div>
            <div className="showModalWrap-box-commonfooter">
                <span onClick={() => this.closeNotFoundAlibabaSupplierProductErrorDailog()} className="showModalWrap-box-footer-btn">我知道了</span>
            </div>
        </ShowModal>
        <ShowModal titleName={"货源不支持铺货代发"} showModal={this.state.showNotFoundAlibabaSupplierProductError} hideBtn={true} width={'450px'} cancelDailog={() => this.closeNotFoundAlibabaSupplierProductErrorDailog()} showLeftTopBtn={true}
        titleIcon={<span className='iconfont icon-gantan warnColor' style={{fontSize:'24px',marginRight:'10px'}}></span>} > 
            <div style={{fontSize:'16px',padding:'10px',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center'}}>
                <div>
                    <span>该货源未获得分销授权，无法进行铺货、关联、更换。您可以换个货源或者联系供应商将该商品设置为支持分销</span>
                </div>
            </div>
            <div className="showModalWrap-box-commonfooter">
            <span onClick={() => window.open('https://www.yuque.com/jessie-bvwmn/qqsqc7/gtpzq3','_blank')} className="showModalWrap-box-footer-btn">查看教程</span>
                <span onClick={() => this.closeNotFoundAlibabaSupplierProductErrorDailog()} className="showModalWrap-box-footer-btn cancleBtn">关闭</span>
            </div>
        </ShowModal>
        <MyLoading isLoading={this.state.isLoading} title={this.state.loadingTitle} isStopOperate={true} fullCenter={true} />
      </ShowModal>
    );
  }



};

export default withRouter(ChangeProductsModule);



// WEBPACK FOOTER //
// ./src/components/changeProductsModule/index.jsx